module.exports = __webpack_public_path__ + "static/media/burger.6cee589c.png";